import PropTypes from 'prop-types';
import StrikeThroughWrapper from 'components/containers/strikethrough-wrapper';

const TaskAssigneeCell = ({ task }) => {
  if (!task) return null;

  const { owner_info, completed_at } = task;

  return (
    <StrikeThroughWrapper hasStrikeThrough={!!completed_at}>{owner_info ? owner_info.name : null}</StrikeThroughWrapper>
  );
};

TaskAssigneeCell.propTypes = {
  task: PropTypes.object.isRequired,
};

export default TaskAssigneeCell;
